import { FB_Template, Measure, MeasureConfig, MeasureConfigAverageType } from "@algomusinc/domain";
import { calculatePercentageChangeInMeasure } from "./calculatePercentageChangeInMeasure";
import { getColumnFormattedValue } from "./getColumnFormattedValue";
import { calculatePercentageInMeasure } from "./calculatePercentageInMeasure";

export const calculateMeasureTotal = (measureCode: string, component: any, columnData?: any, column?: any) => {
  let measureConfig = (column && column.data && column.data.measureConfigData) || new MeasureConfig();

  // send total as zero
  if (measureConfig.isTotalZero) {
    return getColumnFormattedValue(0, measureConfig, component.percent, component.currency, component.currencyCode);
  }

  const yearlist = component.gridListUI.filter((e: any) => e.isSelected);
  let avgCount: any = component.gridListUI.filter((e: any) => e.isSelected && e.title != "Total");

  // calculate total as average of all weeks(leaf nodes)
  if (measureConfig.isAveraged == MeasureConfigAverageType.TotalAverage || measureConfig.isAveraged == MeasureConfigAverageType.BothTotalAndRollupAverage) {
    const totalAverage = calculateLeafNodeLevelTotalMeasureAverage(avgCount, measureCode, measureConfig);
    return getColumnFormattedValue(totalAverage, measureConfig, component.percent, component.currency, component.currencyCode);
  }
  if (measureConfig.isSplitPercent) {
    let totalColumn = component.gridListUI.find((e: any) => e.title == "Total");
    const totalAverage = calculateSplitPercent(totalColumn, measureCode, component);
    return getColumnFormattedValue(totalAverage, measureConfig, component.percent, component.currency, component.currencyCode);
  }
  let total: any = 0;
  if (columnData && component.mivPlanners.includes(component.fbTemplateId)) {
    columnData = columnData.split('--');
    if (columnData.length > 0) {
      // Use the correct response model key (handles both MIV and DC grids)
      const responseModelKey = component.fbForecastMIVResponseModelKey || 'fbForecastMIVResponseModel';
      const responseModel = yearlist[0]?.[responseModelKey];
      if (!responseModel || !Array.isArray(responseModel)) {
        return 0;
      }
      component.mIVResponseModelIndex = responseModel.findIndex((e: any) => e.itemId == columnData[2] && e.channelId == columnData[3]);
      if (component.mIVResponseModelIndex < 0) {
        return 0;
      }
    }
  }
  let isSkip = false;
  let measure: any;
  measure = component.masterMeasureList.find((e: any) => e.code == measureCode)
  yearlist.forEach((week: any, index: number) => {
    if (isSkip) return; // skipping the iterations for slightly fast computation
    if (week.title !== 'Total') {
      let measureValue;
      if (component.mivPlanners.includes(component.fbTemplateId)) {
        const responseModel = week[component.fbForecastMIVResponseModelKey];
        const itemData = responseModel?.[component.mIVResponseModelIndex];
        measureValue = itemData?.[component.parentKey]?.[measureCode];
      } else {
        measureValue = week[component.parentKey][measureCode];
      }
      if (component.multipleAggregatedMeasures.includes(measureCode)) {
        if (measureValue == 'Multiple') {
          total = 'Multiple';
          isSkip = true;
        } else if (index > 0) {
          const prevResponseModel = yearlist[index - 1][component.fbForecastMIVResponseModelKey];
          const prevItemData = prevResponseModel?.[component.mIVResponseModelIndex];
          let previousCellMeasure = prevItemData?.[component.parentKey]?.[measureCode];
          let isSameValue = measureConfig.isComment ? measureValue != previousCellMeasure : +measureValue != +previousCellMeasure;
          if (isSameValue) {
            total = 'Multiple';
            isSkip = true;
          } else {
            total = measureValue;
          }
        } else {
          total = measureValue;
        }
      }
      else if (measureConfig.isLowHierarchy) {
        total = measureValue == 'Multiple' ? measureValue : +(measureValue || 0);
      } else {
        if (measureConfig.isComment) {
          if (!measureValue) {
            return;
          } else if (!total) {
            total = measureValue;
          } else if (measureValue !== total) {
            total = 'Multiple Comments';
            isSkip = true;
          }
        } else if (measureValue === 'Multiple %') {
          total = 'Multiple %';
        } else if (measureConfig.isMultiple) {
          if (total !== 'Multiple' && !isNaN(measureValue)) {
            if (!total && total !== 0) {
              total = 0;
            }
            total = total == measureValue ? total : 'Multiple';
          } else {
            total = 'Multiple';
          }
        }else if(measureValue === 'Multiple'){
          total = 'Multiple ';
          isSkip = true;
        }
        else if (total !== 'Multiple %' && !isNaN(measureValue)) {
          if (!total && total !== 0) {
            measureValue = 0;
          }
          total = +measureValue + total;
        }
      }
    }
  });
  if (measureCode === 'ChangeInFCPct') {
    const baselineFCMeasureId: number = 730;
    const updatedFCMeasureId: number = 731;
    const calculatedTotal = calculatePercentageChangeInMeasure(component.uiList, baselineFCMeasureId, updatedFCMeasureId, column, 'TotalValue');
    if (calculatedTotal != undefined)
      total = calculatedTotal * 100;

  } else if (measureCode == 'ChangeInProfitPct') {
    const baselineProfitMeasureId: number = 736;
    const updatedProfitMeasureId: number = 737;
    const calculatedTotal = calculatePercentageChangeInMeasure(component.uiList, baselineProfitMeasureId, updatedProfitMeasureId, column, 'TotalValue');
    if (calculatedTotal != undefined)
      total = calculatedTotal * 100

  } else if (measureCode == 'ChangeInSalesRevenuePct') {
    const baselineSalesRevenueMeasureId: number = 733;
    const updatedSalesRevenueMeasureId: number = 734;
    const calculatedTotal = calculatePercentageChangeInMeasure(component.uiList, baselineSalesRevenueMeasureId, updatedSalesRevenueMeasureId, column, 'TotalValue');
    if (calculatedTotal != undefined)
      total = calculatedTotal * 100;

  } else if (measureCode == 'ChangeInProfitMarginPct') {
    const baselineProfitMarginMeasureId: number = 903;
    const updatedSalesMeasureId: number = 904;
    const calculatedTotal = calculatePercentageChangeInMeasure(component.uiList, baselineProfitMarginMeasureId, updatedSalesMeasureId, column, 'TotalValue');
    if (calculatedTotal != undefined)
      total = calculatedTotal * 100;
  } else if (measureCode == 'BaselineProfitMarginPct') {
    const baselineProfitMarginMeasureId: number = 736;
    const updatedSalesMeasureId: number = 733;
    const calculatedTotal = calculatePercentageInMeasure(component.uiList, baselineProfitMarginMeasureId, updatedSalesMeasureId, column, 'TotalValue');
    if (calculatedTotal != undefined)
      total = calculatedTotal * 100;
  }
  else if (measureCode == 'UpdatedProfitMarginPct') {
    const updatedProfitMeasureId: number = 737;
    const updatedSalesMeasureId: number = 734;
    const calculatedTotal = calculatePercentageInMeasure(component.uiList, updatedProfitMeasureId, updatedSalesMeasureId, column, 'TotalValue');
    if (calculatedTotal != undefined)
      total = calculatedTotal * 100;
  }
  if (column) {
    column.data['TotalValue'] = total;
    column.data['Total'] = total;
  }
  if (component.fbTemplateId == FB_Template.Split_Percentage) {
    if (measureCode.split('--').length > 1 && column && column.data && column.data.measureTypeId !== 4) {
      if (measureCode.indexOf('Pct') > -1) {
        measureConfig.decimalPlaces = 2;
        measureConfig.isDecimal = true;
        measureConfig.isPercent = true;
      } else {
        measureConfig = new MeasureConfig();
      }
    } else if (measureCode.split('--').length > 1 && column && column.data && column.data.measureTypeId == 4) {
      measureConfig.decimalPlaces = 2;
      measureConfig.isDecimal = true;
      measureConfig.isCurrency = true;


    }
  }
  return getColumnFormattedValue(total, measureConfig, component.percent, component.currency, component.currencyCode);

}


/* To calculate total week level (or whatever which has children array empty) average of measures */
function calculateLeafNodeLevelTotalMeasureAverage(tree: any[], measureCode: string, measureConfig: any): number {
  let total = 0;
  let count = 0;

  const traverse = (nodes: any[]) => {
    for (const node of nodes) {
      if (node.children && node.children.length > 0) {
        traverse(node.children); // go deeper
      } else {
        // Leaf node — perform sum/count logic
        const value = parseFloat(node.measures?.[measureCode] || '0');
        let condition = measureConfig.ignoreZeros ? !isNaN(value) && value : !isNaN(value)
        if (condition) {
          total += value;
          count += 1;
        }
      }
    }
  };

  traverse(tree);

  return count === 0 ? 0 : total / count;
}
function calculateSplitPercent(column: any[], measureCode: string, component: any) {
  let unitMeasureCode = measureCode.replace(/Pct$/, "");
  const leafNode = component.gridListUI.find((e: any) => e.leaf);
  let objectKeys = Object.keys(leafNode?.measures || {}).filter(key => key.includes('--'));
  let totalMix: any = objectKeys.find(m => m.includes("Total Mix") && !m.includes("Pct"));
  let measures = [totalMix, unitMeasureCode];
  let total = 0;
  const calculateSplitMeasures = (nodes: any[], measure: any) => {
    for (const node of nodes) {
      if (node.children && node.children.length > 0) {
        calculateSplitMeasures(node.children, measure);
      } else {
        const value = parseFloat(node.measures?.[measure] || '0');
        total += value;
      }
    }
  };
  measures.forEach((measure: any) => {
    calculateSplitMeasures(component.gridListUI.filter((e: any) => e.isSelected && e.title != "Total"), measure);
    column[component.parentKey][measure] = total;
    total = 0;
  });
  // }
  if (column[component.parentKey][unitMeasureCode] && column[component.parentKey][totalMix] && column[component.parentKey][totalMix] != 0) {
    return (column[component.parentKey][unitMeasureCode] * 100 / column[component.parentKey][totalMix]).toFixed(2);
  }
  if (column[component.parentKey][unitMeasureCode] == column[component.parentKey][totalMix]) {
    return 100;
  }

  return 0;

}
